import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminStudentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { resetRetrieveStudent, retrieveStudent } from "./retrieve-student";

const initialState: RetrievalState<AdminStudentVM | null> = { fetching: "idle", data: null };

export const retrieveStudentReducer = createReducer<RetrievalState<AdminStudentVM | null>>(initialState, builder => {
  builder.addCase(retrieveStudent.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveStudent.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveStudent.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetRetrieveStudent, () => {
    return initialState;
  });
});
